import { render, staticRenderFns } from "./AccountingCategory.vue?vue&type=template&id=d04f0ffc"
import script from "./AccountingCategory.vue?vue&type=script&lang=js"
export * from "./AccountingCategory.vue?vue&type=script&lang=js"
import style0 from "./AccountingCategory.vue?vue&type=style&index=0&id=d04f0ffc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports